export var SpmTestIds;
(function (SpmTestIds) {
    SpmTestIds["TimeframeButton"] = "timeFrame-filter-button";
})(SpmTestIds || (SpmTestIds = {}));
//# sourceMappingURL=test-ids.enum.js.map